module.exports = __webpack_public_path__ + "img/ES05.89056c0a.svg";